import { render, staticRenderFns } from "./ActivitiesDataTable.vue?vue&type=template&id=12b49ffc&scoped=true"
import script from "./ActivitiesDataTable.vue?vue&type=script&lang=js"
export * from "./ActivitiesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b49ffc",
  null
  
)

export default component.exports